import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function ProtocolesInternes() {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="container my-5">
      <h1 className="display-4 mb-4 text-center">Protocoles Internes des Clubs</h1>
      <p className="lead text-center">
        Consultez les protocoles pour organiser vos activités, gérer les financements et le matériel.
      </p>

      <hr />

      {/* Section Organisation des Activités */}
      <div className={`protocol-card mb-4 ${activeSection === 'activities' ? 'active' : ''}`} onClick={() => toggleSection('activities')}>
        <div className="protocol-header text-primary">
          <h2>Organisation des Activités</h2>
        </div>
        <div className={`protocol-body ${activeSection === 'activities' ? 'show' : 'collapse'}`}>
          <ul className="list-unstyled no-dark-mode">
            <li className="mb-3"><strong>Planification :</strong> Toute activité doit être planifiée au moins 2 semaines à l'avance et validée par le coordinateur des clubs.</li>
            <li className="mb-3"><strong>Réservation des lieux :</strong> Les salles et espaces extérieurs doivent être réservés au préalable.</li>
            <li className="mb-3"><strong>Encadrement :</strong> Chaque activité sportive doit être encadrée par un adulte responsable.</li>
            <li className="mb-3"><strong>Communication :</strong> Les participants doivent être informés au moins deux semaines avant l'activité.</li>
          </ul>
        </div>
      </div>

      {/* Section Gestion des Financements */}
      <div className={`protocol-card mb-4 ${activeSection === 'finances' ? 'active' : ''}`} onClick={() => toggleSection('finances')}>
        <div className="protocol-header text-primary">
          <h2>Gestion des Financements</h2>
        </div>
        <div className={`protocol-body ${activeSection === 'finances' ? 'show' : 'collapse'}`}>
          <ul className="list-unstyled no-dark-mode">
            <li className="mb-3"><strong>Demande de financement :</strong> Les clubs peuvent soumettre des demandes avec un budget détaillé.</li>
            <li className="mb-3"><strong>Suivi des dépenses :</strong> Un rapport des dépenses doit être fourni après chaque activité financée.</li>
            <li className="mb-3"><strong>Collecte de fonds :</strong> Les clubs peuvent organiser des événements pour collecter des fonds sous supervision.</li>
            <li className="mb-3"><strong>Transparence :</strong> Tous les financements doivent être gérés avec transparence.</li>
          </ul>
        </div>
      </div>

      {/* Section Gestion du Matériel */}
      <div className={`protocol-card mb-4 ${activeSection === 'material' ? 'active' : ''}`} onClick={() => toggleSection('material')}>
        <div className="protocol-header text-primary">
          <h2>Gestion du Matériel</h2>
        </div>
        <div className={`protocol-body ${activeSection === 'material' ? 'show' : 'collapse'}`}>
          <ul className="list-unstyled no-dark-mode">
            <li className="mb-3"><strong>Inventaire :</strong> Chaque club doit tenir un inventaire précis du matériel mis à disposition.</li>
            <li className="mb-3"><strong>Emprunt de matériel :</strong> Le matériel doit être emprunté avec un formulaire d'emprunt et rendu en bon état.</li>
            <li className="mb-3"><strong>Entretien :</strong> Le matériel doit être entretenu régulièrement pour éviter les accidents.</li>
            <li className="mb-3"><strong>Stockage :</strong> Le matériel doit être stocké dans des espaces dédiés (Bureau des élèves / Salle de stockage).</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ProtocolesInternes;
